// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"9abc9d84","853":"db8108ff","892":"cffafb7c"}[chunkId] + ".chunk.css";
};